import * as actions from 'actions';

const INITIAL_STATE = {
  counsellor: null
};

export default (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case actions.CHAT_ACTIVE_STATE_UPDATE:
      return {
        ...action.chatActiveState
      };

    default:
      return state;
  }
};



/** WEBPACK FOOTER **
 ** ./src/members/state/chat/activeState/reducer.js
 **/